// A1 Level Aggregator - Beginner
// Tüm A1 ünite içeriklerini birleştirir

import { A1_UNIT_1 } from './kariyerContentsA1Unit1';
import { A1_UNIT_2 } from './kariyerContentsA1Unit2';
import { A1_UNIT_3 } from './kariyerContentsA1Unit3';
import { A1_UNIT_4 } from './kariyerContentsA1Unit4';
import { A1_UNIT_5 } from './kariyerContentsA1Unit5';
import { A1_FINAL } from './kariyerContentsA1Final';

export const A1_LEVEL = {
  ...A1_UNIT_1,  // Present Simple - Olumlu
  ...A1_UNIT_2,  // Present Simple - Olumsuz ve Soru
  ...A1_UNIT_3,  // There is / There are
  ...A1_UNIT_4,  // Can / Could
  ...A1_UNIT_5,  // Imperatives
  ...A1_FINAL,   // Final Sınavı
};

export default A1_LEVEL;
